import { AccountUserInvitation } from '@/service';

/**
 * @class @name UserInvitation
 * @description Exposes menu store module
 */
export default class UserInvitation {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name loadUserInvitationPendingList
			 * @description used to fetch app registration
			 * @param {function} commit
			 */
			async loadUserInvitationPendingList() {
				return AccountUserInvitation.pendingList();
			},

			/**
			 * @async @name addUserInvitation
			 * @param {function} commit
			 */
			async addUserInvitation(context, payload) {
				return AccountUserInvitation.post(payload);
			},

			/**
			 * @async @name deleteUserInvitation
			 * @param {function} commit
			 */
			async deleteUserInvitation(context, id) {
				return AccountUserInvitation.delete(id);
			},

			/**
			 * @async @name reinvite
			 * @param {function} commit
			 */
			async reinvite(context, { id, payload }) {
				return AccountUserInvitation.delete(id).then(() => AccountUserInvitation.post(payload));
			}
		};
	}
}
